export enum FormatValidationsErrorMessages {
  InvalidFormat = 'Use valid format',
  FieldRequired = 'Field is required',
}
